import { capitalize, join, map, pipe, split, toLowerCase } from "remeda";

//#region src/stringUtils.ts
function compact(source) {
	return source.filter((s) => !!s);
}
function combine(opts = "", ...params) {
	let options = { joinWith: " " };
	if (opts && typeof opts === "object") options = opts;
	else params = [opts, ...params];
	const { joinWith } = options;
	return compact(params).join(joinWith);
}
function humanize(source, opts = {}) {
	const { capitalize: toCapitalize = false } = opts;
	const humanizedSource = (source || "").replace(/_/g, " ").replace(/(?!^)[A-Z]/g, (replacement) => {
		return ` ${replacement.toLowerCase()}`;
	});
	if (toCapitalize) return pipe(humanizedSource, toLowerCase(), split(" "), map(capitalize()), join(" "));
	return humanizedSource;
}
function camelize(str) {
	return str?.replace(/^([A-Z])|[\s-_/]+(\w)/g, (_match, p1, p2) => {
		if (p2) return p2.toUpperCase();
		return p1.toLowerCase();
	});
}
function snakize(str) {
	return str?.replace(/[A-Z]/g, (match, p1) => {
		return (p1 ? "_" : "") + match.toLowerCase();
	});
}

//#endregion
export { camelize, combine, humanize, snakize };